export const textEn =
  {
    what: "What is OTM?",
    sub: "OTM offers real-time insider information on buying and selling strength.",
    tit:"OTM tools will take your trading to the next level",
  };


export const textEs =
  {
    what: "¿QUÉ ES OTM?",
    sub: "OTM ofrece información privilegiada de la fuerza compradora y vendedora en tiempo real.",
    tit:"Las herramientas de OTM llevarán tu trading al próximo nivel",
  };
